import {usePaginatedQuery} from '../../../../util/hooks/use-paginated-query';

import GET_USER_SESSIONS from '../graphql/queries/get-user-sessions.graphql';

const LIMIT = 50;

export const useGetUserSessions = (userId?: string) => {
    const {
        items: userSessions,
        isLoading,
        isFirstLoad,
        error,
        hasNextPage,
        fetchMoreRows,
    } = usePaginatedQuery({
        // @ts-expect-error
        query: GET_USER_SESSIONS,
        queryKey: 'userSessions',
        limit: LIMIT,
        queryVariables: {userId},
    });

    return {
        userSessions,
        isLoading,
        isFirstLoad,
        error,
        hasNextPage,
        fetchMoreRows,
    };
};
